const s = "web-project.checkbox-checked", e = class e extends CustomEvent {
  constructor(t) {
    super(s, { detail: t, bubbles: !0, composed: !0 });
  }
};
e.EVENT_NAME = s;
let c = e;
export {
  s as EVENT_NAME,
  c as default
};
//# sourceMappingURL=WebProjectCheckboxChecked.js.map
